// extracted by mini-css-extract-plugin
export var binWrap = "_8r-q";
export var cardContainer = "_8r-4";
export var cardContent = "_8r-5";
export var cardTappable = "_8r-t";
export var entering = "_8r-8";
export var productImage = "_8r-d";
export var productImageLg = "_8r-j";
export var productImageMd = "_8r-h";
export var productImagePlaceholder = "_8r-e";
export var productImagePlaceholderLg = "_8r-k";
export var productImagePlaceholderMd = "_8r-i";
export var productImagePlaceholderSm = "_8r-g";
export var productImagePlaceholderXl = "_8r-m";
export var productImageSm = "_8r-f";
export var productImageXl = "_8r-l";
export var progressBarBackground = "_8r-1";
export var progressBarContainer = "_8r-0";
export var progressBarFill = "_8r-2";
export var remainingCount = "_8r-r";
export var scanIconContainer = "_8r-3";
export var scanInputContainer = "_8r-o";
export var scanInputIconCircle = "_8r-n";
export var skipOverlay = "_8r-b";
export var slideInUp = "_8r-9";
export var slideOutRight = "_8r-7";
export var sliding = "_8r-6";
export var successOverlay = "_8r-a";
export var titleClamp = "_8r-s";
export var visible = "_8r-c";
export var workflowBottomBar = "_8r-p";